import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const ContactWireRepository = RepositoryFactory.get('RailwayRepository')['ContactWireRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(ContactWireRepository)

export const STORE_MODULE_NAME = 'contactWire';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
